import { createContext, useContext, useState } from "react";

const ZonaAgenciaContext = createContext();

export const ZonaAgenciaProvider = ({ children }) => {
    const [zona, setZona] = useState("");
    const [agencia, setAgencia] = useState("");

    return (
        <ZonaAgenciaContext.Provider value={{ zona, setZona, agencia, setAgencia }}>
            {children}
        </ZonaAgenciaContext.Provider>
    );
};

// Hook de conveniencia
export const useZonaAgencia = () => useContext(ZonaAgenciaContext);